export enum SettingTabs {
    DashBoard = 0,
    Discount = 1,
    PaymentTerm = 2,
    PromisedTime = 3,
    TaxMaintenance = 4,
    CommonSetup = 5,
    AccountingCode = 6,
    PaymentMethods = 7,
    Company = 8,
    EquipmentWarranty = 9
}
